import Languages from "./languages";

export default Languages;
